module.exports = __webpack_public_path__ + "static/img/10-3.9be82bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10-3.jpg
// module id = pQRV
// module chunks = 0